import showNewsletterSubscribeModal from './newsletter-card';
import { ready } from './utils';

const updateNewsletterSubscription = async (endpoint, newsletterId) => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]');
  const jwt = document.querySelector('#user_jwt');

  const headers = new Headers({
    Accept: 'application/json',
    'content-type': 'application/json',
    'X-CSRF-Token': csrfToken ? csrfToken.content : 'TEST_CSRF_TOKEN', // Provide a fallback for Selenium testing
  });
  const requestBody = {
    newsletter_id: newsletterId,
  };
  if (jwt) {
    requestBody.jwt = jwt.value;
  }
  const payload = {
    method: 'POST',
    headers: headers,
    credentials: 'same-origin',
    body: JSON.stringify(requestBody),
  };
  const request = new Request(endpoint, payload);
  return fetch(request);
};

const subscribeAll = async (e) => {
  const endpoint = e.target.dataset.endpoint;
  const currentUserPresent = e.target.dataset.currentUser;
  const newsletterCards = document.querySelectorAll('.newsletter-card[data-lang="en"]');

  if (currentUserPresent === 'true') {
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    const headers = new Headers({
      Accept: 'application/json',
      'content-type': 'application/json',
      'X-CSRF-Token': csrfToken ? csrfToken.content : 'TEST_CSRF_TOKEN', // Provide a fallback for Selenium testing
    });
    const payload = {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
    };
    const request = new Request(endpoint, payload);
    const response = await fetch(request);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    newsletterCards.forEach((card) => card.classList.add('newsletter-subscribed'));
    verifyAddAllButton();
  } else {
    newsletterCards.forEach((card) => card.classList.add('newsletter-subscribed'));
    showNewsletterSubscribeModal('Subscribe to All Newsletters');
  }
};

ready(() => {
  const addAllBtn = document.querySelector('.add-all-newsletter');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', subscribeAll);
    verifyAddAllButton();
  }
});

export const verifyAddAllButton = () => {
  const addAllNewsletterBtn = document.querySelector('.add-all-newsletter');
  if (!addAllNewsletterBtn) {
    return;
  }
  const allNewslettersCount = document.querySelectorAll(
    '.newsletter-card[data-lang="en"]:not(.premium-newsletter-card)'
  ).length;
  const subscribedNewsletterCount = document.querySelectorAll(
    '.newsletter-subscribed[data-lang="en"]:not(.premium-newsletter-card)'
  ).length;

  if (allNewslettersCount === subscribedNewsletterCount) {
    addAllNewsletterBtn.classList.add('hide-add-all-button');
  } else {
    addAllNewsletterBtn.classList.remove('hide-add-all-button');
  }
};

export default updateNewsletterSubscription;
